<template>
  <div class="nb-adulte-container">
    <div :style="{ backgroundImage: 'url(' + img + ')' }" class="img-responsive">
    </div>
    <div class="d-flex vertical-center display-element prtb-60px " :style="{ backgroundImage: 'url(' + img + ')' }">
      <div>
        <div class="row vertical-center wrap-reverse mt-20px inputs-minus-plus" v-for="(input, index) in listOfInputs" :key="index">
          <div class="d-flex vertical-center global-input">
            <div>
              <img :src="minusImg" class="cursor-pointer img-plus-minus" @click="removeTo(input.label)" />
            </div>
            <input v-focus-end type="number" v-model="result[input.label]" class="nb-adulte-input"
              @input="$emit('update:modelValue', result);checkError()" min="0"/>
            <div>
              <img :src="plusImg" class="cursor-pointer img-plus-minus" @click="addTo(input.label)" />
            </div>
          </div>
          <div class="text-center labels">
            <div class="label-nb">{{ input.label }}</div>
            <div class="description-nb">{{ input.description }}</div>
          </div>
        </div>
        <div class="error text-align-end">{{ error }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import minusImg from "@/assets/images/minus.png";
import plusImg from "@/assets/images/plus.png";
export default {
  data() {
    return { 
      minusImg,
      plusImg,
      result: {},
      error:null
    };
  },
  props: {
    img: String,
    listOfInputs: Array,
    modelValue: Object
  },
  methods: {
    addTo(nb) {
      this.result[nb]++;
      this.$emit('update:modelValue', this.result)
      this.checkError()
    },
    removeTo(nb) {
      if(this.result[nb]!==0){
        this.result[nb]--;
        if (this.result[nb] < 0) {
          this.result[nb] = 0
        }
        this.$emit('update:modelValue', this.result)
        this.checkError()

      }
    },
    checkError(){
      let error=true
      Object.keys(this.result).forEach(element=>{
        if(this.result[element]>0){
          error=false
        }
      })
      if(error){
        this.error="Il doit minimalement y avoir un nombre au dessus de 0"
        this.$emit('onError', true)
      }
      else{
        this.error=null
        this.$emit('onError', false)
      }
    }
  },
  directives: {
    focusEnd: {
      mounted(el) {
        el.addEventListener('focus', () => {
          if (el.type === 'number') {
            el.type = 'text';
            const length = el.value.length;
            el.setSelectionRange(length, length);
            el.type = 'number';
          } else {
            const length = el.value.length;
            el.setSelectionRange(length, length);
          }
        });
      }
    }
  },
  mounted() {
    this.listOfInputs.forEach(element => {
      this.result[element.label] = 0
    })
  },
  watch: {
    modelValue(newVal) {
      this.result = newVal;
    }
  }
};
</script>
<style scoped>
.display-element {
  justify-content: end;
}
.nb-adulte-container {
  position: relative;
  background-color: white;
  display: flex;
  justify-content: space-between;
  border-bottom-right-radius: 50px;
  box-shadow: 4px 4px 24px 0px rgba(0, 0, 0, 0.15);
  margin-top:10px;
  flex-wrap:wrap;
}
.prtb-60px{
  padding-top:60px;
  padding-bottom:60px;
  padding-right:60px;
  box-sizing:border-box;
  background-size:auto 100%;
  background-repeat: no-repeat;
  min-height:350px;
  width:100%;
}
.nb-adulte-input {
  width: 75px;
  height: 35px;
  padding: 10px 20px 10px 20px;
  box-shadow: 4px 4px 24px 0px rgba(0, 0, 0, 0.15);
  border: 3px solid var(--text-color);
  font-size: 35px;
  font-family: var(--font);
  text-align: center;
}

.label-nb {
  color: var(--text-color);
  text-align: left;
  font-family: var(--font);
  font-size: 25px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.wrap-reverse{
  flex-wrap: wrap-reverse !important;
}
.description-nb {
  font-family: var(--font);
  color: var(--text-color);
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 28.2px;
  /* 141% */
}
.img-plus-minus{
    width:60px;
  }
  .img-responsive{
    display: none;
  }
@media screen and (max-width: 1300px) {
  .nb-adulte-img {
    min-height:250px;
}
.nb-adulte-input {
  width: 50px;
  height: 20px;
  font-size: 25px;
}
}
@media screen and (max-width: 900px) {
  .prtb-60px{
    padding-top:20px;
    padding-bottom:20px;
    padding-right:20px;
    padding-left:20px;
    min-height: 250px;

  }
}
@media screen and (max-width: 750px) {
  .prtb-60px{
    background-image: none !important;
  }
  .display-element {
    justify-content: center;
  }
  .img-responsive{
    display: block !important;
    box-sizing:border-box;
    background-size:cover;
    background-position: top center;
    background-repeat: no-repeat;
    min-height:350px;
    width:100%;
  }
  .inputs-minus-plus{
    justify-content: center !important;
  }
  .labels>*{
    text-align: center;
  }
  .text-align-end{
    justify-content: center;
    text-align: center;
  }
  .global-input{
    width:100%;
    justify-content: center;
  }
}
@media screen and (max-width: 600px) {
  .nb-adulte-container {
    margin-top: 45px;
  }
  .nb-adulte-img {
    width: 100%;
  }

  .nb-adulte-img>img {
    width: 100%;
  }
  .label-nb {
    font-size: 18px;
  }
  .display-element {
    justify-content: center;
  }
  .p-60px{
    padding:5px;
  }
  .prtb-60px{
    background-size:100% auto;
    background-position: bottom;
  }

}
@media screen and (max-width: 350px) {
  .img-plus-minus{
    width:60px;
  }
}
</style>
